<script lang="ts">
  /**
 *
 */
  export let hintId: string;

  export let variant: "default" | "error" | "success" | "warning" = "default";
  export let disabled: boolean = false;

  export let hint: string | undefined = undefined;

  export let counterValue: string | undefined = undefined;
  export let minCounter: number | undefined = undefined;
  export let maxCounter: number | undefined = undefined;
  $: showCounter = (minCounter ?? maxCounter) !== undefined;
  $: minCounterText = minCounter === undefined ? "" : ` (min. ${minCounter})`;
  $: maxCounterText = maxCounter === undefined ? "" : ` (max. ${maxCounter})`;
  $: counterText = `${counterValue?.length ?? 0}${minCounterText}${maxCounterText}`;
</script>

{#if hint || showCounter}
  <div
    class="hint"
    class:hint--error={variant === "error"}
    class:hint--warning={variant === "warning"}
    class:hint--success={variant === "success"}
    class:hint--disabled={disabled}
  >
    {#if hint}
      <small class="hint__hint" id={hintId}>{hint}</small>
    {/if}
    {#if showCounter}
      <!-- aria-hidden -> because minlength/maxlength is set on input element -->
      <small class="hint__counter" aria-hidden="true">{counterText}</small>
    {/if}
  </div>
{/if}

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  .hint {
    width: 100%;
    display: grid;
    margin-top: tokens.$oc-component-form-hint-gap-y;
    grid-column-gap: 16px;

    color: tokens.$oc-component-form-default-hint-color;

    &__hint {
      font: tokens.$oc-component-form-hint-font;
    }

    &__counter {
      grid-column-start: 2;
      justify-self: end;
      font: tokens.$oc-component-form-hint-font;
    }

    &--error {
      color: tokens.$oc-component-form-error-hint-color;
    }

    &--success {
      color: tokens.$oc-component-form-success-hint-color;
    }

    &--disabled {
      color: tokens.$oc-component-form-disabled-hint-color;
    }
  }
</style>
